module.exports = __webpack_public_path__ + "static/media/use_graph01_jpn.54fa2be3.jpg";